import React from 'react';

import { SelectedOffer } from '../../../utils/backend-api/subscribe';
import { CustomToaster } from '../../BaseUI';
import SubscriptionForm from '../../SubscriptionForm';
import PlanOptions from './PlanOptions';

interface ReferralSubscription {
  referralOffer: SelectedOffer;
  referringSubName: string;
  referringSubGuid: string;
  userFullName?: string;
  userEmail?: string;
  stripeCustomerId?: string;
}

const Subscription = ({
  referralOffer,
  referringSubName,
  referringSubGuid,
  userFullName,
  userEmail,
  stripeCustomerId,
}: ReferralSubscription) => {
  return (
    <div className="-tw-mt-20">
      <CustomToaster />
      <PlanOptions referralOffer={referralOffer} referringSubName={referringSubName} />
      <div className="tw-w-full sm:tw-w-8/12 lg:tw-w-6/12 tw-mx-auto tw-px-12">
        <SubscriptionForm
          formLocation="referral_subscribe"
          buttonText="Subscribe"
          selectedOffer={referralOffer}
          referringSubscriberGuid={referringSubGuid}
          referringSubscriberName={referringSubName}
          userFullName={userFullName}
          userEmail={userEmail}
          stripeCustomerId={stripeCustomerId}
        />
      </div>
    </div>
  );
};

export default Subscription;
